// src/hooks/useNotifications.js
// Fase 4 de notificaciones-sistema.md: inbox in-app. Escucha en tiempo real la
// colección `notifications` (el bus, Fase 2) filtrada por dueño, y expone las no
// leídas + una función para marcarlas. Sin orderBy en la query a propósito — combinar
// un equality filter con un orderBy en otro campo pide un índice compuesto que este
// proyecto no gestiona (no hay firestore.indexes.json); se ordena en el cliente, mismo
// patrón que getProgramResponses/getAllUserResponses en study-service.js.

import { useState, useEffect, useCallback } from "react";
import { collection, query, where, onSnapshot, doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../services/firebase";

export function useNotifications(userId, { unreadOnly = true } = {}) {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (!userId) {
      setNotifications([]);
      return;
    }
    const q = query(collection(db, "notifications"), where("userId", "==", userId));
    const unsubscribe = onSnapshot(q, (snap) => {
      const items = snap.docs
        .map((d) => ({ id: d.id, ...d.data() }))
        .filter((n) => !unreadOnly || !n.readAt)
        .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
      setNotifications(items);
    });
    return unsubscribe;
  }, [userId, unreadOnly]);

  const markAsRead = useCallback((notificationId) => {
    return updateDoc(doc(db, "notifications", notificationId), { readAt: serverTimestamp() });
  }, []);

  return { notifications, markAsRead };
}
